(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["philosophy"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new Map();
    function initialize(root) {
      const mount = root.querySelector('.philosophy__bg');
      if (!mount || instances.has(root)) return;
      const canvas = document.createElement('canvas');
      canvas.setAttribute('aria-hidden', 'true');
      mount.appendChild(canvas);
      const ctx = canvas.getContext('2d');
      if (!ctx) return;
      const hero = root.querySelector('.philosophy__hero');
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let width = 0, height = 0, frame = 0, previous = 0, time = 0;
      let visible = false, destroyed = false;
      let pointerX = 0, pointerY = 0, driftX = 0, driftY = 0;
      function resize() {
        width = mount.clientWidth;
        height = mount.clientHeight;
        const ratio = Math.min(devicePixelRatio || 1, 1.75);
        canvas.width = Math.round(width * ratio);
        canvas.height = Math.round(height * ratio);
        canvas.style.width = width + 'px';
        canvas.style.height = height + 'px';
        ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
        render();
      }
      function point(a, strand) {
        const u = a / Math.PI - 1;
        const cycle = time % 13;
        const progress = Math.max(0, Math.min(1, (cycle - 4) / 4.5));
        const eased = progress * progress * (3 - 2 * progress);
        const envelope = Math.sin(Math.PI * progress) ** 2;
        const crest = -1.65 + eased * 3.3;
        const distance = (u - crest) / 0.32;
        const fold = Math.exp(-distance * distance) * envelope;
        const tension = Math.sin(u * 2.2 + 0.4) * 0.32;
        const angle = -0.65 + u * 0.75 + fold * 2.2 + driftY * 0.12;
        const fineWave = Math.sin(u * 5 - time * 0.22 + strand) * 0.025;
        const x = u * 3.65 + fold * 0.3 + driftX * 0.10;
        const y = strand * 1.05 * Math.cos(angle) + tension - fold * 0.75 + fineWave;
        const z = strand * 1.05 * Math.sin(angle) + fold * 1.05;
        const rx = x * 0.985 + y * 0.174;
        const ry = -x * 0.174 + y * 0.985;
        const perspective = 8 / (8 - z);
        const mobile = width < 720;
        const scaleX = width * (mobile ? 0.25 : 0.20);
        const scaleY = height * (mobile ? 0.29 : 0.36);
        return [width * 0.51 + rx * scaleX * perspective,
          height * (mobile ? 0.58 : 0.56) + ry * scaleY * perspective, z];
      }
      function render() {
        if (!width || !height || destroyed) return;
        ctx.clearRect(0, 0, width, height);
        const halo = ctx.createRadialGradient(width * 0.72, height * 0.52, 0, width * 0.72, height * 0.52, height * 0.7);
        halo.addColorStop(0, 'rgba(187, 178, 165, 0.16)');
        halo.addColorStop(1, 'rgba(245, 242, 239, 0)');
        ctx.fillStyle = halo;
        ctx.fillRect(0, 0, width, height);
        const count = width < 720 ? 66 : 108;
        const steps = width < 720 ? 120 : 200;
        const paths = [];
        for (let i = 0; i < count; i++) {
          const strand = i / (count - 1) * 2 - 1;
          const points = [];
          let depth = 0;
          for (let j = 0; j <= steps; j++) {
            const p = point(j / steps * Math.PI * 2, strand);
            points.push(p);
            depth += p[2];
          }
          paths.push({points, depth: depth / steps, strand, index: i});
        }
        paths.sort((a, b) => a.depth - b.depth);
        for (const path of paths) {
          const gradient = ctx.createLinearGradient(width * 0.35, height * 0.2, width, height * 0.8);
          const copper = path.index > count * 0.76;
          gradient.addColorStop(0, copper ? 'rgba(177, 79, 37, 0.50)' : 'rgba(30, 37, 51, 0.36)');
          gradient.addColorStop(0.48, copper ? 'rgba(168, 64, 30, 0.66)' : 'rgba(36, 58, 103, 0.67)');
          gradient.addColorStop(1, copper ? 'rgba(125, 62, 42, 0.36)' : 'rgba(26, 28, 36, 0.52)');
          ctx.strokeStyle = gradient;
          ctx.lineWidth = path.index % 12 === 0 ? 1.25 : 0.72;
          ctx.beginPath();
          path.points.forEach((p, i) => i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]));
          ctx.stroke();
        }
        const veil = ctx.createLinearGradient(0, 0, width, 0);
        veil.addColorStop(0, 'rgba(245, 242, 239, 0.25)');
        veil.addColorStop(0.24, 'rgba(245, 242, 239, 0.18)');
        veil.addColorStop(0.51, 'rgba(245, 242, 239, 0.08)');
        veil.addColorStop(0.68, 'rgba(245, 242, 239, 0)');
        ctx.fillStyle = veil;
        ctx.fillRect(0, 0, width, height);
        const topFade = ctx.createLinearGradient(0, 0, 0, 120);
        topFade.addColorStop(0, 'rgba(245, 242, 239, 0.96)');
        topFade.addColorStop(1, 'rgba(245, 242, 239, 0)');
        ctx.fillStyle = topFade;
        ctx.fillRect(0, 0, width, 120);
        if (width < 720) {
          const readingSpace = ctx.createLinearGradient(0, height * 0.40, 0, height * 0.60);
          readingSpace.addColorStop(0, 'rgba(245, 242, 239, 0)');
          readingSpace.addColorStop(0.5, 'rgba(245, 242, 239, 0.40)');
          readingSpace.addColorStop(1, 'rgba(245, 242, 239, 0)');
          ctx.fillStyle = readingSpace;
          ctx.fillRect(0, height * 0.40, width, height * 0.20);
        }
      }
      function tick(now) {
        frame = 0;
        if (destroyed || !visible || document.hidden || motion.matches) return;
        time += previous ? Math.min((now - previous) / 1000, 0.05) : 0;
        previous = now;
        driftX += (pointerX - driftX) * 0.035;
        driftY += (pointerY - driftY) * 0.035;
        render();
        frame = requestAnimationFrame(tick);
      }
      function update() {
        cancelAnimationFrame(frame);
        frame = 0;
        previous = 0;
        if (!visible || document.hidden) return;
        if (motion.matches) { time = 0; driftX = 0; driftY = 0; render(); }
        else frame = requestAnimationFrame(tick);
      }
      function move(event) {
        const bounds = hero.getBoundingClientRect();
        pointerX = (event.clientX - bounds.left) / bounds.width * 2 - 1;
        pointerY = (event.clientY - bounds.top) / bounds.height * 2 - 1;
      }
      function leave() { pointerX = 0; pointerY = 0; }
      const resizeObserver = new ResizeObserver(resize);
      resizeObserver.observe(mount);
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; update(); });
      observer.observe(hero);
      hero.addEventListener('pointermove', move, { passive: true });
      hero.addEventListener('pointerleave', leave);
      document.addEventListener('visibilitychange', update);
      motion.addEventListener('change', update);
      instances.set(root, () => {
        destroyed = true;
        cancelAnimationFrame(frame);
        observer.disconnect();
        resizeObserver.disconnect();
        hero.removeEventListener('pointermove', move);
        hero.removeEventListener('pointerleave', leave);
        document.removeEventListener('visibilitychange', update);
        motion.removeEventListener('change', update);
        canvas.remove();
        instances.delete(root);
      });
    }
    document.querySelectorAll('[data-philosophy]').forEach(initialize);
    document.addEventListener('shopify:section:load', event => {
      event.target.querySelectorAll('[data-philosophy]').forEach(initialize);
    });
    document.addEventListener('shopify:section:unload', event => {
      for (const [root, dispose] of instances) if (event.target.contains(root)) dispose();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
